import {
  ClickAwayListener,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Box,
} from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { useSelector } from 'react-redux';
import { logout } from '../../lib/api';
import { GrowerSelector } from './GrowerSelector';
import { DashboardSubHeader } from '../../sections/soil-sampling/DashboardSubHeader';
import { selectors as authSelectors } from '../../store/dux/auth-dux';
import { usePermissions } from '../../hooks/use-permissions';
import { useAdminContext } from '../../sections/admin/context.jsx';

const subHeaderComponentRegistry = {
  DashboardSubHeader,
};

export function SubHeader({ component }) {
  const { isAuthenticated, isAdmin } = useSelector(authSelectors.currentUser);
  const adminContext = useAdminContext();
  const permissions = usePermissions();
  const [anchorEl, setAnchorEL] = useState(null);
  const handleMenu = (event) => {
    setAnchorEL(event.currentTarget);
  };

  const handleClickAway = () => {
    setAnchorEL(null);
  };

  const handleClose = () => {
    setAnchorEL(null);
  };

  const menuOpen = Boolean(anchorEl);

  const SubHeaderContent = !component
    ? GrowerSelector
    : subHeaderComponentRegistry[component];

  return (
    <Toolbar variant="dense" sx={{ minHeight: 48, backgroundColor: '#333' }}>
      <Box sx={{ flex: 1 }}>
        <SubHeaderContent />
      </Box>

      {isAuthenticated && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <div>
            <IconButton
              aria-label="menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              color="inherit"
              onClick={handleMenu}
              style={{ marginLeft: '1rem' }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={menuOpen}
              onClose={handleClose}
            >
              <MenuItem onClick={logout}>Logout</MenuItem>
              {permissions.includes('MANAGE_OPERATIONS') && (
                <MenuItem
                  onClick={handleClose}
                  component={Link}
                  to={isAdmin ? '/grower-management' : '/operation-management'}
                >
                  Manage Operations
                </MenuItem>
              )}
              {permissions.includes('MANAGE_GROWERS') && (
                <MenuItem
                  onClick={handleClose}
                  component={Link}
                  to="/organization-management"
                >
                  Manage Organizations
                </MenuItem>
              )}
              {permissions.includes('MANAGE_GROWERS') && (
                <MenuItem
                  onClick={handleClose}
                  component={Link}
                  to="/user-management"
                >
                  Manage Users
                </MenuItem>
              )}
              {adminContext.hasAccess && (
                <MenuItem onClick={handleClose} component={Link} to="/admin">
                  Admin
                </MenuItem>
              )}
            </Menu>
          </div>
        </ClickAwayListener>
      )}
    </Toolbar>
  );
}
